import * as z from 'zod';

export const yesNoEnum = z.enum(['Yes', 'No'], { required_error: 'Please select an option' });
export const trueFalseEnum = z.enum(['true', 'false'], { required_error: 'Please select an option' });

export const amountStringSchema = z
  .string({ required_error: 'An amount is required' })
  .min(1, { message: 'An amount is required' });
